export const nl2br = (text) => text.replace(/(?:\r\n|\r|\n)/g, '<br>')
export const br2nl = (text) => text.replace(/<br\s*\/?>/gm, '\n')
